let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("26g1i")).then(() => parcelRequire('bs4rl'));